import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { DestinationType, IndexedCollection } from '../../../shared/types'
import {
  AARData,
  AarDetailsResponse,
  MAKES_FIELD,
  RATING_SUMMARY_FIELD,
  SERVICES_FIELD,
  TowDestinationResponse
} from './aar.types'
import { DrrHttpClient } from '../../../http/drr-http-client'
import { indexCollection } from '../../../shared/utils'
import { RapService } from '../../rap/rap.service'
import { EvStationService } from './evstation.service';
import { AARDataAdapter } from "../../../shared/adapters/AARDataAdapter";

@Injectable({
  providedIn: 'root',
})
export class AarService {

  constructor(
    private httpClient: DrrHttpClient,
    private rapService: RapService,
    private evStationService: EvStationService,
    private adapter: AARDataAdapter,
  ) { }

  getAARs$({
    latitude,
    longitude,
    make,
    model,
    radius,
    limit,
    country,
    type,
    isCollision,
  }: {
    latitude,
    longitude,
    make,
    model,
    radius?,
    limit?,
    country?,
    type?,
    isCollision?,
  }, destinationType: DestinationType): Observable<IndexedCollection<AARData>> {
    switch (destinationType) {
      case DestinationType.DEALER:
        return this.rapService.getAarsFromTowDestination$({
          latitude,
          longitude,
          make,
          model,
          country,
          type,
          ...(isCollision ? { isCollision } : {}),
        })

      case DestinationType.EV_STATION:
        return this.evStationService.search$(latitude, longitude, this.getEvSearchLimit(limit), radius)

      case DestinationType.AAR:
      default:
        return this.search$(latitude, longitude, make, limit, isCollision)

    }
  }

  private search$(latitude, longitude, make, limit, isCollision): Observable<IndexedCollection<AARData>> {
    return this.httpClient
      .get<TowDestinationResponse<AarDetailsResponse>>('bff/tow-destinations/aars', {
        params: {
          requireResult: 'true',
          latitude: String(latitude),
          longitude: String(longitude),
          // HttpParams stringifies undefined into the literal "undefined", so an absent make
          // has to be dropped rather than passed through.
          ...(make ? { make: String(make) } : {}),
          fields: `${MAKES_FIELD},${SERVICES_FIELD},${RATING_SUMMARY_FIELD}`,
          ...(limit ? { limit: String(limit) } : {}),
          ...(isCollision ? { isCollision: String(isCollision) } : {}),
        },
      })
      .pipe(
        map((response) => {
          const aars = response.results.map((aar) => this.adapter.adaptTowDestination<AarDetailsResponse>(aar))

          return indexCollection<AARData, 'id'>(aars, 'id')
        })
      )
  }

  private getEvSearchLimit(limit) {
    return this.rapService.isRapUser() ? this.rapService.getLimitWithinRadius() : limit
  }
}
